import React, { CSSProperties } from "react";
import ReactLoading from "react-loading";
import styled from "styled-components/native";
import { ColorKeys } from "styled-system";
import { StyleProp, Text, ViewStyle } from "react-native";
type Props = {
  message?: any;
  color?: ColorKeys;
  style?: StyleProp<ViewStyle>;
  loaderSize?: number;
  textSize?: number;
};
const LoaderContainer = styled.View<Props>(({ style, ...props }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  //   ...style,
}));
export class Loader extends React.Component<Props> {
  render() {
    return (
      <LoaderContainer style={this.props.style}>
        {/* <ReactLoading
					type="spinningBubbles"
					color={this.props.color || "white"}
					height={this.props.loaderSize || 35}
					width={this.props.loaderSize || 35}
				/> */}
        <Text>Loading</Text>
        {/* <div style={{ marginLeft: 20 }}
          className="loader-text">
          <Text variant="regular"
            fontSize={this.props.textSize || 36}
            color={this.props.color} >{this.props.message !== undefined ? this.props.message : "Caricamento"}</Text>
        </div> */}
      </LoaderContainer>
    );
  }
}

